
import { Card, CardHeader, CardTitle, CardContent, CardFooter } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { useNavigate } from "react-router-dom";

interface EditArticleErrorProps {
  error: string;
}

const EditArticleError = ({ error }: EditArticleErrorProps) => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col items-center pt-10 min-h-screen bg-gray-50">
      <Card className="w-full max-w-lg">
        <CardHeader>
          <CardTitle className="text-red-500">Error</CardTitle>
        </CardHeader>
        <CardContent>
          <p>{error}</p>
        </CardContent>
        <CardFooter>
          <Button onClick={() => navigate("/admin")}>Back to Admin Dashboard</Button>
        </CardFooter>
      </Card>
    </div>
  );
};

export default EditArticleError;
